function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n\n  button {\n    padding: 0.8rem 1rem;\n  }\n\n  @media (max-width: 576px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  &:first-child {\n    border-right: none;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  &:last-child {\n    border-left: none;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { TiThMenu, TiThSmall } from "react-icons/ti";
import Button from "../button";
import { LayoutModesEnum } from "../layout-switch/consts";
var ButtonContainer = styled.div(_templateObject());
var LayoutButtonStyles = styled(Button)(_templateObject1());
var LayoutButton = function(param) {
    var listMode = param.listMode, switchToGrid = param.switchToGrid, switchToList = param.switchToList;
    return /*#__PURE__*/ React.createElement(ButtonContainer, {
        "data-testid": "product-list-layout-buttons-container",
        className: "toolbar-change-layout"
    }, /*#__PURE__*/ React.createElement(LayoutButtonStyles, {
        "data-testid": "product-list-layout-button-grid",
        className: listMode === LayoutModesEnum.Grid ? "active" : "inactive",
        primary: listMode === LayoutModesEnum.Grid,
        onClick: switchToGrid,
        outline: listMode !== LayoutModesEnum.Grid
    }, /*#__PURE__*/ React.createElement(TiThSmall, null)), /*#__PURE__*/ React.createElement(LayoutButtonStyles, {
        "data-testid": "product-list-layout-button-list",
        className: listMode === LayoutModesEnum.List ? "active" : "inactive",
        primary: listMode === LayoutModesEnum.List,
        onClick: switchToList,
        outline: listMode !== LayoutModesEnum.List
    }, /*#__PURE__*/ React.createElement(TiThMenu, null)));
};
export default LayoutButton;
